module.exports = __webpack_public_path__ + "img/Emile Smith-Rowe.70e1b2d8.png";